import React from 'react';

export default function TimerRing({ timeLeft, total = 15 }) {
  const r = 28;
  const circ = 2 * Math.PI * r;
  const pct = timeLeft / total;
  const color = timeLeft > 8 ? '#4caf50' : timeLeft > 4 ? '#f0b429' : '#e23636';

  return (
    <div className="timer-ring">
      <svg width="68" height="68" viewBox="0 0 68 68">
        <circle cx="34" cy="34" r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="5" />
        <circle
          cx="34" cy="34" r={r}
          fill="none"
          stroke={color}
          strokeWidth="5"
          strokeDasharray={circ}
          strokeDashoffset={circ * (1 - pct)}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 0.3s linear, stroke 0.3s' }}
        />
      </svg>
      <span className="timer-num" style={{ color }}>{timeLeft}</span>
    </div>
  );
}
